import { Modal } from "antd";
import { AxiosResponse } from "axios";
import Button from "components/shared/Button/Button";
import TokenService from "../services/httpClient/tokenManager";
import CloseBtn from "components/shared/CloseBtn/CloseBtn";
import ErrorCard from "components/shared/ErrorCard/ErrorCard";
import HelperText from "components/shared/HelperText/HelperText";
import LoadingCard from "components/shared/LoadingCard/LoadingCard";
import OTPField from "components/shared/OTPField/OTPField";
import SuccessCard from "components/shared/SuccessCard/SuccessCard";
import { useAppDispatch } from "customHooks/useAppDispatch";
import { useAppSelector } from "customHooks/useAppSelector";

import { Formik, Field, Form, ErrorMessage } from "formik";
import { indiviualValidationSchema } from "pages/Auth/signup/FormModel/indiviualValidationSchema";
import { userTypes } from "pages/Dashboard/Home/types/userTypes";
import SecurityQuestions from "pages/Dashboard/UserProfile/Forms/SecurityQuestions";
import {
  pinValidationSchema,
  saveSecurityQuestionPayloadSchema,
} from "pages/Dashboard/UserProfile/Forms/validationSchemas";
import { SecurityModals } from "pages/Dashboard/UserProfile/components/models";
import { createContext, useCallback, useEffect, useRef, useState } from "react";
// import { getSecurityQuestionsStatus } from "store/api/account";
import { SaveSecurityQuestionsPayload } from "store/api/models";
import {
  getSecurityQuesAsync,
  saveSecurityQuesAsync,
} from "store/reducers/auth-slice";
import { getSecurityQuesStatusAsync } from "store/reducers/auth-slice";
import { getUserCorporateDocumentsAsync } from "store/reducers/document-slice";
type UserProfileContextProp = {
  userType: userTypes;
};

export const UserProfileContext = createContext<UserProfileContextProp>(
  {} as UserProfileContextProp
);

type UserProfileProviderProps = {
  children?: React.ReactNode;
};

class renderTracker {
  private static _renderCount: number = 0;

  static increment() {
    this._renderCount++;
  }

  static get count() {
    return this._renderCount;
  }
}

export const UserProfileProvider: React.FC<UserProfileProviderProps> = ({
  children,
}) => {
  const [modal, setModal] = useState<SecurityModals | undefined>(undefined);
  const [questionAnswers, setQueAns] = useState<SaveSecurityQuestionsPayload>();
  const [secStat, setSecurityQuestionStatus] = useState<boolean>();
  const [pinError, setPinError] = useState("");
  const { CustomerType } = useAppSelector((state) => state.user.userDetails);
  const [isManuallyClosed, setIsManuallyClosed] = useState(false);

  // Instead of setting `showModal` automatically, do this:
  const { isLoading, securityQuestions, securityStatus } = useAppSelector(
    (state) => state.auth
  );
  const showModal = securityStatus?.IsStatusSet === false && !isManuallyClosed;

  const dispatch = useAppDispatch();

  const setUpSecurityQuestions = useCallback(
    async function () {
      if (
        questionAnswers &&
        saveSecurityQuestionPayloadSchema.isValidSync(questionAnswers)
      ) {
        setModal(SecurityModals.sending);
        const resp = await dispatch(saveSecurityQuesAsync(questionAnswers!));

        if (resp.meta.requestStatus === "fulfilled") {
          setModal(SecurityModals.successSecQuestion);
          dispatch(getSecurityQuesStatusAsync());
          setQueAns(undefined);
        } else if (resp.meta.requestStatus === "rejected") {
          setPinError(resp.payload);
          setModal(SecurityModals.error);
          setQueAns(undefined);
        }
      }
    },
    [dispatch, questionAnswers]
  );

  // let loginTimeout = useRef(
  //   setTimeout(() => {
  //     TokenService.removeUser();
  //     window.location.href = "/"
  //   },
  //   +TokenService.getExpiresIn()
  //   )
  //   )

  useEffect(() => {
    // if (!securityStatus && !modal) {
    //   if (renderTracker.count % 13 === 0) {
    //     dispatch(getSecurityQuesStatusAsync());
    //   }
    //   renderTracker.increment();
    // } else 
    if (securityStatus && typeof securityStatus.IsStatusSet === "boolean") {
      // Show modal only if status is false (i.e. not yet set)
      if (securityStatus.IsStatusSet === false && modal === undefined) {
        setModal(SecurityModals.viewSecurityQuestions);
      }
    } 
  }, [securityStatus, modal, dispatch]);

  useEffect(() => {
    if (!isLoading && !securityQuestions) {
      dispatch(getSecurityQuesAsync());
    }
  }, [isLoading, securityQuestions, dispatch]);

  useEffect(() => {
    if ((CustomerType?.toLowerCase() as userTypes) === "corporate") {
      dispatch(getUserCorporateDocumentsAsync());
    }
  }, [dispatch, CustomerType]);

  return (
    <UserProfileContext.Provider
      value={{ userType: CustomerType?.toLowerCase() as userTypes }}
    >
      {children}
      <Modal
        // width={500}
        width={
          modal === SecurityModals.viewSecurityQuestions
            ? 500
            : modal === SecurityModals.enterPin
            ? 400
            : modal === SecurityModals.sending
            ? 400
            : 500
        }
        bodyStyle={{
          overflowY: "auto",
          height: modal === SecurityModals.viewSecurityQuestions ? "80vh" : "",
          paddingRight: "0.5em",
          paddingLeft: "0.5em",
        }}
        className="notification-modal"
        closable
        centered
        // open={typeof secStat === "boolean" && !secStat}
        open={showModal}
        onCancel={() => {
          setSecurityQuestionStatus(true); // Optional, just to mark as complete
          setModal(undefined);
        }}
      >
        {modal === SecurityModals.viewSecurityQuestions && (
          <div style={{ padding: "0.5rem 1rem 1rem 1rem" }}>
            <div className="y">
              <CloseBtn
                onClose={() => {
                  console.log("close modal");
                  setSecurityQuestionStatus(false);
                  setIsManuallyClosed(true); // override auto-open

                  setModal(undefined);
                }}
              />
            </div>
            <h1 className="signin-title text-left">Set Security questions</h1>
            <p className="signin-text text-left">
              Select unique security questions and put in answers only you would
              remember
            </p>
            <div className="formik">
              <SecurityQuestions
                questions={securityQuestions ?? []}
                onClose={(values) => {
                  setQueAns({ ...values, pin: "" });
                  setModal(SecurityModals.enterPin);
                }}
              />
            </div>
          </div>
        )}
        {modal === SecurityModals.enterPin && (
          <div style={{ padding: "1.5rem 1rem" }}>
            <h1
              className="signin-title text-left"
              style={{ textAlign: "left", fontSize: "1.3em" }}
            >
              Please enter your PIN
            </h1>
            <div className="formik">
              <Formik
                initialValues={{ pin: "" }}
                onSubmit={(gg: { pin: string }) => {
                  setQueAns({
                    pin: gg.pin,
                    securityAnswers: questionAnswers?.securityAnswers!,
                  });
                  setUpSecurityQuestions();
                }}
                validationSchema={pinValidationSchema}
              >
                {(formik) => (
                  <Form onSubmit={formik.handleSubmit} autoComplete="off">
                    <div className="otp-box">
                      <label style={{ fontSize: "0.85em" }}>PIN</label>
                      <Field
                        component={OTPField}
                        inputType="password"
                        name="pin"
                        numInputs={4}
                        inputStyle="otp"
                        autoComplete="off"
                      />
                      <ErrorMessage name="pin">
                        {(msg: string) => <HelperText>{msg}</HelperText>}
                      </ErrorMessage>
                      {/* <p style={{ color: "#03883", cursor: "pointer" }}>
                        Forgot PIN ?
                      </p> */}
                    </div>
                    <Button
                      size="lg"
                      label="save"
                      type="submit"
                      variant={
                        !(formik.isValid && formik.dirty)
                          ? "disabled"
                          : "primary"
                      }
                    />
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        )}
        {modal === SecurityModals.successSecQuestion && (
          <SuccessCard
            title="Come on in! Your account has been setup."
            closeModal={() => {
              setModal(undefined);
            }}
          >
            <p>
              Welcome to QuickBucks! Take instant loans today and make your
              dreams a reality.
            </p>
          </SuccessCard>
        )}
        {modal === SecurityModals.error && (
          <ErrorCard
            title="Failed"
            closeModal={() => setModal(SecurityModals.viewSecurityQuestions)}
          >
            {/* <p>You have entered an Incorrect PIN. Please try again.</p> */}
            <p>{pinError}</p>
            <Button
              label="Retry"
              variant="tertiary"
              onClick={() => setModal(SecurityModals.viewSecurityQuestions)}
            />
          </ErrorCard>
        )}
        {modal === SecurityModals.sending && (
          <LoadingCard title="Setting security questions …">
            <p>Please wait while you data is being saved.</p>
          </LoadingCard>
        )}
      </Modal>
    </UserProfileContext.Provider>
  );
};

export default UserProfileProvider;
